var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMultiply = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M15.712 8.288a5.25 5.25 0 1 1-7.425 7.424 5.25 5.25 0 0 1 7.425-7.424m-.636.636a4.35 4.35 0 1 1-6.152 6.152 4.35 4.35 0 0 1 6.152-6.152",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M13.22 13.856a.45.45 0 1 0 .636-.636L12.636 12l1.22-1.22a.45.45 0 1 0-.636-.636L12 11.364l-1.22-1.22a.45.45 0 0 0-.636.636l1.22 1.22-1.22 1.22a.45.45 0 0 0 .636.636l1.22-1.22z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMultiply);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/multiply.69a920b5.svg";